import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  ModalCloseButton,
  Button,
  useDisclosure,
  Input,
  Flex,
  Box,
  Spinner
} from '@chakra-ui/react';
import { api } from '../../../../services/api';
import { useQuery } from 'react-query';
import { useRef, useState } from 'react';
import * as T from '../../../../components/Table';
import { Pagination } from '../../../../components/Pagination';

async function getTabelas({ nomeTabela, page }) {
  const response = await api.get(`/crm-interno/tabelas?tbl=${nomeTabela}&page=${page}`);

  return response.data;
}

export function ListarTabelas() {
  const { isOpen, onOpen, onClose } = useDisclosure();
  const [nomeTabela, setNomeTabela] = useState('');
  const [page, setPage] = useState(1);

  const inputRef = useRef();

  const { data: tabelas, isLoading } = useQuery({
    queryKey: ['tabelas', { nomeTabela }, { page }],
    queryFn: () => getTabelas({ nomeTabela, page }),
    refetchOnWindowFocus: false,
    enabled: !!nomeTabela,
    onSuccess: (data) => {
      console.log(data);
    }
  });

  async function handleListarTabelas(e) {
    e.preventDefault();

    setNomeTabela(inputRef.current.value);
  }

  console.log(nomeTabela);

  console.log(tabelas);

  return (
    <>
      <Button onClick={onOpen} variant="outline" maxW="300px" w="100%">
        Listagem de Tabelas
      </Button>

      <Modal isOpen={isOpen} onClose={onClose} size="xl">
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>Listagem de Tabelas</ModalHeader>
          <ModalCloseButton />
          <ModalBody height="600px">
            <Flex gap={2} alignItems="center" as="form" onSubmit={handleListarTabelas}>
              <Input ref={inputRef} name="nomeTabela" placeholder="Digite o nome da coluna" />
              <Button type="submit">Buscar</Button>
            </Flex>

            {isLoading && (
              <Box minH="343px" display="flex" justifyContent="center" alignItems="center">
                <Spinner />
              </Box>
            )}
            {tabelas && tabelas?.data?.length !== 0 && (
              <T.Table mt={5}>
                <T.Thead>
                  <T.Tr>
                    <T.Th>Nome da Tabela</T.Th>
                    <T.Th>Nome da Coluna</T.Th>
                  </T.Tr>
                </T.Thead>

                <T.Tbody>
                  {tabelas?.data?.map((tabela) => (
                    <T.Tr key={tabela.nome_tabela}>
                      <T.Td p={1}>{tabela.nome_tabela}</T.Td>
                      <T.Td p={1}>{tabela.nome_coluna}</T.Td>
                    </T.Tr>
                  ))}
                </T.Tbody>
              </T.Table>
            )}
          </ModalBody>

          <ModalFooter>
            {tabelas && tabelas?.data?.length !== 0 && (
              <Flex mr="auto">
                <Pagination
                  page={page}
                  setPage={setPage}
                  limit={tabelas?.limit}
                  totalPages={tabelas?.last_page}
                  isDisabled={isLoading}
                />
              </Flex>
            )}
            <Button colorScheme="blue" mr={3} onClick={onClose}>
              Fechar
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </>
  );
}
